import { QueryClient } from "@tanstack/react-query";

/**
 * Client React Query partagé dans toute l'application.
 * Importez-le dans les pages qui ont besoin d'invalider le cache
 * après une mutation : queryClient.invalidateQueries({ queryKey: QUERY_KEYS.xxx })
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Les données de référence sont considérées fraîches pendant 10 minutes
      staleTime: 10 * 60 * 1000,
      // Le cache est conservé 30 minutes après que le composant se démonte
      gcTime: 30 * 60 * 1000,
      // Un seul retry sur erreur réseau (évite de flooder l'API)
      retry: 1,
      // Ne pas refetch à chaque focus de fenêtre (évite du trafic inutile)
      refetchOnWindowFocus: false,
    },
  },
});
